// @flow
import React, { PureComponent } from 'react';

export type Props = {
  caption: string,
  src: string,
  figureClassName: string,
  containerClassName: string,
  articleTitle?: string,
};

class Figure extends PureComponent<Props> {
  props: Props;

  static defaultProps = {
    caption: '',
    src: '',
    figureClassName: '',
    containerClassName: '',
    articleTitle: '',
  };

  render() {
    const { src, caption, figureClassName, containerClassName, articleTitle } = this.props;
    let alt;

    if (caption) {
      alt = caption; // TODO : ajouter Crédit venant de l'API
    } else if (articleTitle) {
      alt = `Illustration de ${articleTitle}`;
    }

    return (
      <figure className={containerClassName}>
        <div className={figureClassName} style={{ backgroundImage: `url(${src})` }}>
          {/* @apsulis TBD idéalement il faudrait la description de l'image (envoyée par l'API ?), sinon le titre de l'article qu'elle illustre genre alt='Illustration de TITRE' et puis sinon met le titre de l'image (s'il existe, titre ≠ nom de fichier) */}
          <img src={src} alt={alt} />
        </div>
        <figcaption>{caption}</figcaption>
      </figure>
    );
  }
}

export default Figure;
